import { Plane, Ship, Truck } from 'lucide-react';
import { cn } from '@/lib/utils';

interface Props {
  transporte: string;
  modo?: string;
  direccion?: string;
  className?: string;
}

const ICON: Record<string, React.ComponentType<{ className?: string }>> = {
  AIR: Plane,
  SEA: Ship,
  ROA: Truck,
};

export function TransporteBadge({ transporte, modo, direccion, className }: Props) {
  const Icon = ICON[transporte] ?? Truck;
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium border border-ink-200 bg-surface-1 text-ink-700',
        className,
      )}
    >
      <Icon className="h-3 w-3" />
      <span>
        {transporte}
        {modo && <span className="text-ink-400"> · {modo}</span>}
        {direccion && <span className="text-ink-400"> · {direccion}</span>}
      </span>
    </span>
  );
}
